/* eslint-disable @typescript-eslint/no-namespace */

import 'react-json-view-lite/dist/index.css'
import Box from './Box'

const App = () => {
  return (
    <Box fullWidth fullHeight align="center">
      <Box width="400px" fullHeight></Box>
    </Box>
  )
}

export default App
